import {Component, OnInit} from '@angular/core';
import {AuthService} from 'src/app/services/auth/auth.service';
import {Principal} from 'src/app/models/principal/principal';
import { Permission } from 'src/app/models/principal/permission';
import { KeyValueMap } from '../../../models/key-value-map';
import { PermissionsService } from '../../../services/util/permissions.service';
import { RouterSegments } from '../../../models/router-segments';
import { MatMenu } from '@angular/material/menu';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.scss'],
    standalone: false
})
export class UserMenuComponent implements OnInit {

  tenant: string;
  principalAbbreviation: string;
  principal: Principal;
  RouterSegments = RouterSegments;
  isTenantView: boolean;

  constructor(private authService: AuthService, private router: Router, private sidenavService: SidenavService) {
  }

  ngOnInit(): void {
    this.isTenantView = window.location.pathname?.split('/')[2] === 'tenant';
    this.tenant = this.authService.principal.provider;
    this.principal = this.authService.principal;
    this.principalAbbreviation = this.getNameAbbreviation(this.authService.principal);
  }

  logout(): void {
    this.authService.logout();
  }

  private getNameAbbreviation(principal: Principal): string {
    // Does a possibility to not have first and last name exist?
    return principal?.attributes?.given_name.substr(0, 1).toUpperCase()
      + principal?.attributes?.family_name.substr(0, 1).toUpperCase();
  }

  goToMyAccount(): void {
    if (window.location.pathname?.split('/')[2] === 'tenant') {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, 'my-account']);
      this.sidenavService.tenantSelectedMenu = undefined;
    } else {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.MY_ACCOUNT]);
    }
  }

}
